import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
// @material-ui/core components

// core components
import GridContainer from "@components/Grid/GridContainer.js";
import GridItem from "@components/Grid/GridItem.js";
import { useQuery } from "@apollo/client";
import OvsTable from "@components/ReactTable/OvsTable";
import { Column } from "react-table";
import CardWrapper from "@components/Card/CardWrapper";
import { CodeEventContext } from "../context/CodeEventProvider";
import {
  codeEventTableData,
  openTokenColumns,
} from "../constants/codeEventTableData";
import GoBackHeader from "@components/GoBackHeader/GoBackHeader";
import { useAuth } from "admin/auth/context/AuthProvider";
import { getOpenTokenCodeHistoryList } from "../../codeGenerator/queries";

interface IRTable {
  bulkDeleteProducts?: () => void;
  isLoading?: boolean;
  itemId?: string;
}

const CodeEventPage: React.FC<IRTable> = ({
  bulkDeleteProducts,
  isLoading,
  itemId,
}) => {
  const {
    itemData,
    codeEvents,
    loading,
    paging,
    goTo,
    setSearchQuery,
    searchQuery,
    setItemId,
  } = useContext(CodeEventContext);

  const [innerItemId, setInnerItemId] = useState("");
  const { itemIdd } = useParams();
  const { isDistributor, isServicer } = useAuth();

  // Debug logs to understand itemData value
  //console.log("itemData type:", typeof itemData);
  // console.log("itemData value:", itemData);
  // console.log("itemData === 'OPENTOKEN':", String(itemData) === "OPENTOKEN");
  // console.log(
  //   "String(itemData) === 'OPENTOKEN':",
  //   String(itemData) === "OPENTOKEN"
  // );

  const { data: openTokenData, loading: openTokenLoading } = useQuery(
    getOpenTokenCodeHistoryList,
    {
      variables: {
        itemId: itemIdd || innerItemId,
      },
      // Modified skip condition to be more accommodating
      skip: itemData === undefined || String(itemData) !== "OPENTOKEN",
    }
  );

  useEffect(() => {
    if (itemId && !loading) {
      setInnerItemId(itemId);
    } else if (itemIdd) {
      setInnerItemId(itemIdd);
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    setItemId(innerItemId);
    // eslint-disable-next-line
  }, [innerItemId]);

  const columnsToRemove = [
    "userWhoCausedTheChange",
    "typeOfChangeChange",
    "Triggers",
    "hashRoot",
  ];

  const regularColumns = codeEventTableData().header?.filter((item) => {
    if (
      (isDistributor || isServicer) &&
      columnsToRemove.includes(item.Header)
    ) {
      return false;
    }
    return true;
  });

  // Process OpenToken data to extract nodes from edges
  const openTokenHistoryData =
    openTokenData?.getOpenTokenCodeHistoryList?.page?.edges?.map(
      (edge: { node: any }, index: number) => ({ ...edge.node, id: index + 1 })
    ) || [];

  //console.log("openTokenHistoryData:", openTokenHistoryData);
  //console.log("codeEvents:", codeEvents);

  // Modified condition to handle various data types and equality checks
  const useOpenTokenData =
    String(itemData) === "OPENTOKEN" ||
    String(itemData) === "OPENTOKEN" ||
    (typeof itemData === "object" && String(itemData) === "OPENTOKEN");

  // Determine which data to show based on itemData
  const tableData = useOpenTokenData
    ? openTokenHistoryData
    : codeEvents?.map((item, id) => ({ ...item, id: id + 1 })) || [];

  //console.log("useOpenTokenData:", useOpenTokenData);
  //console.log("tableData:", tableData);

  const columns = useOpenTokenData ? openTokenColumns : regularColumns;

  const isTableLoading =
    isLoading || loading || (useOpenTokenData && openTokenLoading);

  return (
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <CardWrapper>
          <GoBackHeader title="Go Back" />
          <OvsTable
            columns={columns as Column[]}
            data={tableData}
            checkedIds={[]}
            bulkDelete={bulkDeleteProducts}
            tableTitle={
              useOpenTokenData ? "Open Token Code History" : "Code Event List"
            }
            isLoading={isTableLoading}
            hideRightToolbar
            goTo={goTo}
            paging={paging}
            setSearchQuery={setSearchQuery}
            searchQuery={searchQuery}
          />
        </CardWrapper>
      </GridItem>
    </GridContainer>
  );
};

export default CodeEventPage;
